<template>
  <div class="invoiceManagement">
    <div class="container_">
      <div class="title_">注意</div>
      <div class="contentView">
        <div>
          本平台支持开具的发票类型有：电子版增值税普通发票、纸质版增值税普通发票、纸质版增值税专用发票。
        </div>
        <div>
          发票内容为“技术服务费”，发票税率为6%，最低开票金额为200元人民币。
        </div>
        <div>
          如您选择开具纸质发票，发票自申请日起15个工作日内寄出，邮费到付，如遇节假日可能会延迟。
        </div>
        <div>
          如您选择开具电子发票，发票自申请日起5个工作日内发送到您开票时填写的邮箱。
        </div>
      </div>
    </div>

    <div class="LayoutContainer">
      <div class="theHeader">
        <div class="tabContainer">
          <div
            v-for="item in pageData.tab_.list"
            :key="item"
            :class="item.type == pageData.tab_.type ? 'active' : ''"
            @click="typeSetting(item.type)"
          >
            {{ item.name }}
          </div>
        </div>

        <div
          class="settingButton"
          v-if="pageData.tab_.type == 1 && pageData.orderCodeArr != ''"
        >
          <div @click="pageJump(1)">开普通发票</div>
          <div @click="pageJump(2)">开增值税专用发票</div>
        </div>
      </div>

      <div class="tableWtyle" v-if="pageData.tab_.type == 1">
        <el-table
          :data="pageData.tableData"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          height="500"
          :header-cell-style="{
            background: '#F5F7FA',
            color: '#303133',
            fontWeight: '800',
          }"
        >
          <el-table-column type="selection" width="55" />
          <el-table-column label="购买服务" width="120">
            <template #default="scope">{{ scope.row.name || "-" }}</template>
          </el-table-column>
          <el-table-column label="金额" width="120">
            <template #default="scope">{{
              scope.row.payPrice + "¥" || "-"
            }}</template>
          </el-table-column>
          <el-table-column label="支付时间">
            <template #default="scope">{{ scope.row.payTime || "-" }}</template>
          </el-table-column>
          <el-table-column label="支付方式" width="120">
            <template #default="scope">
              <div>
                {{ scope.row.payWay == 1 ? "微信" : "支付宝" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="金额（元）" width="200">
            <template #default="scope">{{
              scope.row.discountPrice + "¥" || "-"
            }}</template>
          </el-table-column>
        </el-table>
        <pagingComponent
          @handleCurrentChangeSub="noChangePagination"
          :currentPage="totalnum.page"
          :rows="totalnum.pageSize"
          :total="totalnum.total"
        />
      </div>
      <div class="tableWtyle" v-else>
        <el-table
          :data="pageData.tableData"
          style="width: 100%"
          height="500"
          :header-cell-style="{
            background: '#F5F7FA',
            color: '#303133',
            fontWeight: '800',
          }"
        >
          <el-table-column label="申请时间">
            <template #default="scope">{{
              scope.row.createTime || "-"
            }}</template>
          </el-table-column>
          <el-table-column label="发票抬头">
            <template #default="scope">{{
              scope.row.invoiceTitle || "-"
            }}</template>
          </el-table-column>
          <el-table-column label="发票类型">
            <template #default="scope">{{
              scope.row.type == 1 ? "普通发票" : "增值发票"
            }}</template>
          </el-table-column>
          <el-table-column label="金额">
            <template #default="scope">
              <div>
                {{ scope.row.invoiceAmount + "¥" || "-" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template #default="scope">{{
              scope.row.status == 1
                ? "待审核"
                : scope.row.status == 2
                ? "审核中"
                : scope.row.status == 3
                ? "邮寄中"
                : scope.row.status == 4
                ? "已撤销"
                : scope.row.status == 5
                ? "已完成"
                : "-"
            }}</template>
          </el-table-column>
          <el-table-column label="编辑">
            <template #default="scope">
              <el-button
                v-if="scope.row.status
                !=4"
                type="text"
                size="small"
                @click.prevent="
                  invoiceToBackoutInvoiceFun(scope.row.uniqueCode)
                "
              >
                撤销
              </el-button>
              <div v-else>
                已撤销
              </div>
            </template>
          </el-table-column>
        </el-table>
        <pagingComponent
          @handleCurrentChangeSub="noChangePagination"
          :currentPage="totalnum.page"
          :rows="totalnum.pageSize"
          :total="totalnum.total"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import {
  invoiceToBeInvoiceList,
  invoiceInvoiceList,
  invoiceToBackoutInvoice,
} from "../../api/interfaceList";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import { reactive, computed, onMounted } from "vue";
import pagingComponent from "@/components/pagingComponent/index";
export default {
  name: "invoiceManagement",
  setup() {
    const router = useRouter();
    let pageData = reactive({
      orderCodeArr: "",
      tableData: [],
      tab_: {
        type: 1,
        list: [
          {
            name: "待开票",
            type: 1,
          },
          {
            name: "开票记录",
            type: 2,
          },
        ],
      },
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
    });
    let totalnum = computed(() => {
      return pageData.page;
    });
    function noChangePagination(res) {
      pageData.tableData = [];
      pageData.page.page = res;
      invoiceToBeInvoiceListFun();
    }
    function toView() {
      router.push("withdrawalSetting");
    }
    function handleSelectionChange(value) {
      let arr = [];
      value.map((item) => {
        arr.push(item.orderCode);
        // pageData.orderCodeArr.push(item.orderCode)
      });
      pageData.orderCodeArr = arr;
      console.log(pageData.orderCodeArr);
    }
    function typeSetting(value) {
      pageData.tab_.type = value;
      pageData.page.page = 1;
      pageData.orderCodeArr = "";
      if (pageData.tab_.type == 1) {
        invoiceToBeInvoiceListFun();
      } else {
        invoiceInvoiceListFun();
      }
    }
    function pageJump(type) {
      Cookies.set("orderCodeArr", JSON.stringify(pageData.orderCodeArr));
      router.push({
        path: "invoiceManagementSetting",
        query: {
          type,
        },
      });
    }
    function invoiceToBackoutInvoiceFun(uniqueCode) {
      invoiceToBackoutInvoice({
        uniqueCode,
      }).then((res) => {
        if (res.code == 1) {
          invoiceInvoiceListFun();
        } else {
          ElMessage({
            message: res.message,
          });
        }
      });
    }
    function invoiceToBeInvoiceListFun() {
      invoiceToBeInvoiceList({
        page: pageData.page.page,
        pageSize: pageData.page.pageSize,
        userCode: JSON.parse(Cookies.get("userInformation")).userCode,
      }).then((res) => {
        if (res.code == 1) {
          pageData.tableData = res.data.records;
          pageData.page.total = res.data.pages;
        } else {
          ElMessage({
            message: res.message,
          });
        }
      });
    }
    function invoiceInvoiceListFun() {
      invoiceInvoiceList({
        page: pageData.page.page,
        pageSize: pageData.page.pageSize,
        userCode: JSON.parse(Cookies.get("userInformation")).userCode,
      }).then((res) => {
        if (res.code == 1) {
          pageData.tableData = res.data.records;
          pageData.page.total = res.data.pages;
        } else {
          ElMessage({
            message: res.message,
          });
        }
      });
    }

    onMounted(() => {
      invoiceToBeInvoiceListFun();
    });
    return {
      pageData,
      totalnum,
      noChangePagination,
      toView,
      handleSelectionChange,
      typeSetting,
      pageJump,
      invoiceToBeInvoiceListFun,
      invoiceToBackoutInvoiceFun,
    };
  },
  components: {
    pagingComponent,
  },
};
</script>
<style lang="scss" scope>
.invoiceManagement {
  width: 1050px;
  .container_ {
    width: 100%;
    background: #cce6ff;
    border-radius: 6px;
    padding: 18px 30px;
    box-sizing: border-box;
    margin-bottom: 13px;
    display: flex;
    flex-direction: column;
    .contentView {
      margin-top: 10px;
      div {
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #008aea;
        line-height: 16px;
      }
    }
    .title_ {
      font-size: 12px;
      font-family: AlibabaPuHuiTiR;
      color: #008aea;
    }
  }
  .LayoutContainer {
    width: 100%;
    padding: 4px 30px 10px 30px;
    box-sizing: border-box;
    background: #fff;
    border-radius: 8px;
    .tableStyle {
      width: 100%;
      margin-top: 16px;
      div {
        width: 100%;
        text-align: center;
      }
    }
    .theHeader {
      width: 100%;
      padding-bottom: 12px;
      border-bottom: 1px solid #f7f7f7;
      padding: 12px 0;
      box-sizing: border-box;
      margin-bottom: 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .settingButton {
        display: flex;
        align-items: center;
        div {
          height: 40px;
          font-size: 13px;
          font-family: AlibabaPuHuiTiM;
          color: #ffffff;
          line-height: 40px;
          border-radius: 6px;
          text-align: center;
          margin-right: 16px;
          cursor: pointer;
        }
        div:last-of-type {
          margin: 0;
        }
        div:nth-of-type(1) {
          width: 120px;
          background: #008aea;
        }
        div:nth-of-type(2) {
          width: 144px;
          background: #4a9c5e;
        }
      }
      .tabContainer {
        display: flex;
        align-items: center;
        div {
          font-size: 14px;
          font-family: AlibabaPuHuiTiM;
          color: #909399;
          //   line-height: 64px;
          margin-right: 40px;
          cursor: pointer;
        }
        div:hover {
          color: #008aea;
          transition: 0.4s all;
        }
        .active {
          color: #008aea;
        }
      }
    }
  }
}
</style>
